import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyA9IxJQjk_B83rtfEHIxOKfwiNeMNy7LIs",
  authDomain: "cs-b-speaking-report.firebaseapp.com",
  projectId: "cs-b-speaking-report",
  storageBucket: "cs-b-speaking-report.firebasestorage.app",
  messagingSenderId: "1041815111549",
  appId: "1:1041815111549:web:5a3951c4f3bddae0f9ae14"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app, "asia-northeast1");

export const ADMIN_EMAIL = "urano@hgu.jp";
export const GUEST_EMAIL = "uranoken@gmail.com";
export const ALLOWED_DOMAIN = "hgu.jp";

// 学期と期の定義（month は 0 始まり：0=1月, 9=10月）
// 締切はいずれもその日の 23:59:59
// 学期IDは提出時に termId として保存する。termId のない既存データは第1学期として扱う。
export const TERMS = [
  {
    id: 1, label: "第1学期",
    start: new Date(2026, 3, 1, 0, 0, 0),
    periods: [
      { id: 1, label: "第1期", deadline: new Date(2026, 3, 30, 23, 59, 59), maxPoints: 5 },
      { id: 2, label: "第2期", deadline: new Date(2026, 4, 31, 23, 59, 59), maxPoints: 5 },
      { id: 3, label: "第3期", deadline: new Date(2026, 5, 30, 23, 59, 59), maxPoints: 5 },
      { id: 4, label: "第4期", deadline: new Date(2026, 6, 31, 23, 59, 59), maxPoints: 5 },
    ],
  },
  {
    id: 2, label: "第2学期",
    start: new Date(2026, 7, 1, 0, 0, 0),
    periods: [
      { id: 1, label: "第1期", deadline: new Date(2026, 9, 31, 23, 59, 59), maxPoints: 5 },
      { id: 2, label: "第2期", deadline: new Date(2026, 10, 30, 23, 59, 59), maxPoints: 5 },
      { id: 3, label: "第3期", deadline: new Date(2026, 11, 31, 23, 59, 59), maxPoints: 5 },
      { id: 4, label: "第4期", deadline: new Date(2027, 0, 31, 23, 59, 59), maxPoints: 5 },
    ],
  },
];

export function getTerm(termId) {
  return TERMS.find(t => t.id === termId) || TERMS[0];
}

// 現在日時が属する学期（start を過ぎた最後の学期）
export function getCurrentTermId() {
  const now = new Date();
  let id = TERMS[0].id;
  for (const t of TERMS) {
    if (now >= t.start) id = t.id;
  }
  return id;
}

// 提出データの学期ID（termId のない既存データは第1学期）
export function getSubmissionTermId(s) {
  return s.termId ?? 1;
}

// 学期内での期別得点と繰り越し（繰り越しは学期をまたがない）
export function calcTermScores(submissions, termId) {
  const term = getTerm(termId);
  const termSubs = submissions.filter(s => getSubmissionTermId(s) === term.id);
  let carryover = 0;
  const periods = term.periods.map(p => {
    const periodSubs = termSubs.filter(s => s.periodId === p.id);
    const approved = periodSubs.filter(s => s.status === "approved" || s.status === "modified");
    const earned = approved.reduce((sum, s) => sum + (s.finalPoints ?? s.provisionalPoints ?? 0), 0);
    const effective = Math.min(earned + carryover, p.maxPoints);
    const excess = Math.max(0, earned + carryover - p.maxPoints);
    const result = { ...p, earned, count: periodSubs.length, carryover, effective, excess };
    carryover = excess;
    return result;
  });
  const total = periods.reduce((sum, p) => sum + p.effective, 0);
  const maxTotal = term.periods.reduce((sum, p) => sum + p.maxPoints, 0);
  return { periods, total, maxTotal };
}

export const ACTIVITY_TYPES = {
  A: { label: "A. 集中した英語使用（スピーキング＆リスニング）", pointsPer: 30, unit: "30分あたり1点", example: "例：少人数で英語を話し続ける" },
  B: { label: "B. ゆるやかな英語使用（スピーキング＆リスニング）", pointsPer: 60, unit: "60分あたり1点", example: "例：教室外で英会話的イベントに参加する" },
  C: { label: "C. スピーキングを伴わない英語使用（リスニング中心）", pointsPer: 90, unit: "90分あたり1点", example: "例：英語の講演会、英語の映画（字幕なし）" },
  D: { label: "D. その他", pointsPer: null, unit: "換算方法は個別に判断", example: "" },
};

export function calcProvisionalPoints(type, hours, minutes) {
  const totalMin = (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);
  const info = ACTIVITY_TYPES[type];
  if (!info || !info.pointsPer) return null; // D type
  return Math.floor(totalMin / info.pointsPer);
}

export function getCurrentPeriodId(termId = getCurrentTermId()) {
  const now = new Date();
  const periods = getTerm(termId).periods;
  for (const p of periods) {
    if (now <= p.deadline) return p.id;
  }
  return periods.length;
}
